"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeploymentBuilder = void 0;

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var DeploymentBuilder = /*#__PURE__*/function () {
  function DeploymentBuilder() {
    _classCallCheck(this, DeploymentBuilder);
  }

  _createClass(DeploymentBuilder, null, [{
    key: "buildEntity",

    /**
     * As part of the deployment process, an entity has to be built. In this method, we are building it, based on the data provided.
     * After the entity is built, the user will have to sign the entity id, to prove they are actually who they say they are.
     */
    value: function () {
      var _buildEntity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, pointers) {
        var files,
            metadata,
            timestamp,
            contentFiles,
            hashes,
            hashesByKey,
            filesByHash,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = _args.length > 2 && _args[2] !== undefined ? _args[2] : new Map();
                metadata = _args.length > 3 ? _args[3] : undefined;
                timestamp = _args.length > 4 ? _args[4] : undefined;
                // Reorder input
                contentFiles = Array.from(files.entries()).map(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      name = _ref2[0],
                      content = _ref2[1];

                  return {
                    name: name,
                    content: content
                  };
                }); // Calculate hashes

                _context.next = 6;
                return dcl_catalyst_commons_1.Hashing.calculateHashes(contentFiles);

              case 6:
                hashes = _context.sent;
                hashesByKey = new Map(hashes.map(function (_ref3) {
                  var hash = _ref3.hash,
                      file = _ref3.file;
                  return [file.name, hash];
                }));
                filesByHash = new Map(hashes.map(function (_ref4) {
                  var hash = _ref4.hash,
                      file = _ref4.file;
                  return [hash, file];
                }));
                return _context.abrupt("return", DeploymentBuilder.buildEntityInternal(type, pointers, {
                  hashesByKey: hashesByKey,
                  filesByHash: filesByHash,
                  metadata: metadata,
                  timestamp: timestamp
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildEntity(_x, _x2) {
        return _buildEntity.apply(this, arguments);
      }

      return buildEntity;
    }()
    /**
     * In cases where we don't need upload content files, we can simply generate the new entity. We can still use already uploaded hashes on this new entity.
     */

  }, {
    key: "buildEntityWithoutNewFiles",
    value: function () {
      var _buildEntityWithoutNewFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, pointers, hashesByKey, metadata, timestamp) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", DeploymentBuilder.buildEntityInternal(type, pointers, {
                  hashesByKey: hashesByKey,
                  metadata: metadata,
                  timestamp: timestamp
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function buildEntityWithoutNewFiles(_x3, _x4, _x5, _x6, _x7) {
        return _buildEntityWithoutNewFiles.apply(this, arguments);
      }

      return buildEntityWithoutNewFiles;
    }()
  }, {
    key: "buildEntityInternal",
    value: function () {
      var _buildEntityInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(type, pointers, options) {
        var _a, _b, _c, hashesByKey, entityContent, timestamp, _yield$dcl_catalyst_c, entity, entityFile, filesByHash;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(pointers.length === 0)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error("All entities must have at least one pointer.");

              case 2:
                // Re-organize the hashes
                hashesByKey = (_a = options === null || options === void 0 ? void 0 : options.hashesByKey) !== null && _a !== void 0 ? _a : new Map();
                entityContent = Array.from(hashesByKey.entries()).map(function (_ref5) {
                  var _ref6 = _slicedToArray(_ref5, 2),
                      key = _ref6[0],
                      hash = _ref6[1];

                  return {
                    file: key,
                    hash: hash
                  };
                }); // Calculate timestamp if necessary

                if (!((_b = options === null || options === void 0 ? void 0 : options.timestamp) !== null && _b !== void 0)) {
                  _context3.next = 8;
                  break;
                }

                _context3.t0 = _b;
                _context3.next = 11;
                break;

              case 8:
                _context3.next = 10;
                return DeploymentBuilder.calculateTimestamp();

              case 10:
                _context3.t0 = _context3.sent;

              case 11:
                timestamp = _context3.t0;
                _context3.next = 14;
                return dcl_catalyst_commons_1.buildEntityAndFile(type, pointers, timestamp, entityContent, options === null || options === void 0 ? void 0 : options.metadata);

              case 14:
                _yield$dcl_catalyst_c = _context3.sent;
                entity = _yield$dcl_catalyst_c.entity;
                entityFile = _yield$dcl_catalyst_c.entityFile;
                // Add entity file to content files
                filesByHash = (_c = options === null || options === void 0 ? void 0 : options.filesByHash) !== null && _c !== void 0 ? _c : new Map();
                filesByHash.set(entity.id, entityFile);
                return _context3.abrupt("return", {
                  files: filesByHash,
                  entityId: entity.id
                });

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function buildEntityInternal(_x8, _x9, _x10) {
        return _buildEntityInternal.apply(this, arguments);
      }

      return buildEntityInternal;
    }()
  }, {
    key: "calculateTimestamp",
    value: function () {
      var _calculateTimestamp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var fetcher, _yield$fetcher$fetchJ, datetime;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // We will try to use a global time API, so if the local PC clock is off, it will still work
                fetcher = new dcl_catalyst_commons_1.Fetcher();
                _context4.prev = 1;
                _context4.next = 4;
                return fetcher.fetchJson('https://worldtimeapi.org/api/timezone/Etc/UTC');

              case 4:
                _yield$fetcher$fetchJ = _context4.sent;
                datetime = _yield$fetcher$fetchJ.datetime;
                return _context4.abrupt("return", new Date(datetime).getTime());

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", Date.now());

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 9]]);
      }));

      function calculateTimestamp() {
        return _calculateTimestamp.apply(this, arguments);
      }

      return calculateTimestamp;
    }()
  }]);

  return DeploymentBuilder;
}();

exports.DeploymentBuilder = DeploymentBuilder;